module.exports = __webpack_public_path__ + "img/development-during-recession-top.167f764e.webp";